import React from 'react';
import { App, Article, Main } from '../components/content';
import Header from '../components/layout/Header';
import Sidebar from '../components/layout/Sidebar';
// import HomePage from '../pages';
import { Route, Routes, Navigate } from 'react-router-dom';
import User from '../pages/korisnik/[id]';
import Users from '../pages/korisnik/korisnici';
import Medics from '../pages/medics';
import EditMedic from '../pages/medics/edit';
import EditClinic from '../pages/medics/clinicEdit';
import ViewMedic from '../pages/medics/view';
import Vips from '../pages/vips/vips';
import ReferralProgram from '../pages/referralProgram/referralProgram';
import WebshopAndProducts from '../pages/webshopAndProducts/webshopAndProducts';
import Vip from '../pages/vips/[id]';
import PointsAndGamification from '../pages/pointsAndGamification/pointsAndGamification';
import Profile from '../pages/profile/profile';
import ReportsAndStatistics from '../pages/reportsAndStatistics/reportsAndStatistics';
import SingleOrder from '../pages/webshopAndProducts/[id]';
import { ToastContainer } from 'react-toastify';
import { useAuth } from '../context/useAuth';
import { routes } from '../router/routes';
import { adminRoles } from '../router/roles';
import { usePermissions } from '../context/PermissionsContext';

// A page is open when the user holds its permissions (or, for `menuGroup` pages, can see
// any tab of that group). Non-admin roles listed in allowedRoles still pass by role: those
// pages scope themselves to the user's own network. Routes without permissions keep the
// plain role check.
const ProtectedRoute = ({ route, children, userRole, fallback }) => {
  const { canAll, visibleMenuGroups } = usePermissions();
  const allowedRoles = route.allowedRoles || [];
  const gated = Boolean(route.permissions || route.menuGroup);

  const byRole = gated
    ? allowedRoles.includes(userRole) && !adminRoles.includes(userRole)
    : allowedRoles.includes(userRole);
  const byPermission = route.menuGroup
    ? visibleMenuGroups.some((group) => group.key === route.menuGroup)
    : Boolean(route.permissions) && canAll(route.permissions);

  if (!userRole || !(byRole || byPermission)) {
    return <Navigate to={fallback || '/profile'} replace />;
  }

  return children;
};

const Layout = (props) => {
  const { user } = useAuth();
  const { loading, homeLink, visibleMenuGroups } = usePermissions();
  const hasAdminMenu = visibleMenuGroups.length > 0;

  // Nothing to decide on until the permissions are in; avoids flashing hidden items and
  // redirecting away from a page the user may in fact open.
  if (loading) return null;

  return (
    <App className="app">
      <Main className="main">
        <Header />
        <div
          className={
            hasAdminMenu ? 'app_body app_body--with-sidebar' : 'app_body'
          }
        >
          {hasAdminMenu && <Sidebar />}
          <Article
            className={hasAdminMenu ? 'article--with-sidebar' : undefined}
          >
            <Routes>
              {/* Landing page korisnici */}
              <Route path="/" element={<Navigate to={homeLink} replace />} />
              {/* Uncomment in case home page is required */}
              {/* <Route path="/" element={<HomePage />} /> */}

              {routes?.length > 0 &&
                routes?.map((item) => {
                  const protected_props = {
                    route: item,
                    userRole: user.role,
                    fallback: homeLink,
                  };

                  const render_element = item.isAdminRoute ? (
                    <ProtectedRoute {...protected_props}>
                      {item.element}
                    </ProtectedRoute>
                  ) : (
                    item.element
                  );

                  return <Route path={item.path} element={render_element} />;
                })}

              {/* <Route path="/korisnici" element={<Users />} />
            <Route path="/korisnik/:id" element={<User />} />
            <Route
              path="/points-and-gamification"
              element={<PointsAndGamification />}
            />
            <Route path="/vips" element={<Vips />} />
            <Route path="/vip/:id" element={<Vip />} />
            <Route
              path="/webshop-and-products"
              element={<WebshopAndProducts />}
            />
            <Route path="/order/:id" element={<SingleOrder />} />
            <Route path="/referral-program" element={<ReferralProgram />} />
            <Route path="/medics" element={<Medics />} />
            <Route path="/medics/edit/:id" element={<EditMedic />} />
            <Route path="/medics/view/:id" element={<ViewMedic />} />
            <Route path="/clinic/edit/:id" element={<EditClinic />} />
            <Route path="/clinic/view/:id" element={<ViewClinic />} />
            <Route
              path="/reports-and-statistics"
              element={<ReportsAndStatistics />}
            />
            <Route path="/profile" element={<Profile />} /> */}
            </Routes>
            <ToastContainer position="bottom-right" />
          </Article>
        </div>
      </Main>
    </App>
  );
};

export default Layout;
